// @flow

import styled from 'styled-components';
import type { Theme } from '../../../../../../types';

type Props = {
  open: boolean,
};

export default styled<any, Theme, Props>('div')`
  bottom: 0;
  color: ${props => props.theme.optionPriceExtended.toggle.actionColor};
  font-size: ${props => props.theme.optionPriceExtended.toggle.fontSize};
  line-height: 1;
  position: absolute;
  text-transform: uppercase;
  right: 0;

  &:after {
    content: ${props => (props.open ? "'-'" : "'+'")};
    margin-left: .25rem;
  }
`;
